import { atom, useAtom } from "jotai"

const eventsBufferAtom = atom<Record<string, string>[]>([])

export function useEventsBuffer() {
  return useAtom(eventsBufferAtom)
}
